import { render, staticRenderFns } from "./TeachersPxTop.vue?vue&type=template&id=439af1cf&scoped=true&"
import script from "./TeachersPxTop.vue?vue&type=script&lang=js&"
export * from "./TeachersPxTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439af1cf",
  null
  
)

export default component.exports